import {
    faBuildingColumns,
    faCat,
    faCircle,
    faFilter,
    faHouse,
    faList,
    faMapLocationDot,
    faPaw,
    faUsers,
    faDog,
    faVenus,
    faMars,
    faUser
} from "@fortawesome/free-solid-svg-icons";


export const ENTITY_LIST_CONF = {
    ELEMENTS_PER_ROW_DESKTOP : 1,
    ELEMENTS_PER_PAGE_DESKTOP : 15,
    ELEMENTS_PER_ROW_TABLET : 1,
    ELEMENTS_PER_PAGE_TABLET : 15,
    ELEMENTS_PER_ROW_MOBILE : 1,
    ELEMENTS_PER_PAGE_MOBILE : 15,
}




export const ICON_SCALE_FILTER = 0.055;
export const ICON_SCALE_DEFAULT = 0.05;
export const ICON_SCALE_MOBILE = 0.04;
export const ICON_SCALE_USER = 0.035;



export const MAP_TIPOS_ENTITY_CONFIG = {
    "default": {
        value: "protectora",
        label: "Protectora",
        longLabel: "Protectora de animales",
        faIcon: faPaw,
        colorIcon: "#ff9083",
        scale: ICON_SCALE_DEFAULT,
        scaleMobile: ICON_SCALE_MOBILE,
    },
    protectora: {
        value: "protectora",
        label: "Protectora",
        longLabel: "Protectora de animales",
        faIcon: faPaw,
        colorIcon: "#ff9083",
        scale: ICON_SCALE_DEFAULT,
        scaleMobile: ICON_SCALE_MOBILE,
    }
}




export const MAP_SUBTIPOS_ENTITY_CONFIG = {
    protectora: {
        "default": {
            nameProp:"default",
            value: "default",
            label: "Protectora",
            longLabel: "Protectora de animales",
            faIcon: faPaw,
            colorIcon: "#ff9083",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        albergue: {
            nameProp:"albergue",
            value: "albergue",
            label: "Albergue",
            longLabel: "Albergue de animales",
            faIcon: faHouse,
            colorIcon: "#2bc5c8",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        asociacion: {
            nameProp:"asociacion",

            value: "asociacion",
            label: "Asociación",
            longLabel: "Asociación de animales",
            faIcon: faUsers,
            colorIcon: "#36dc75",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,

        },
        "asociacion-ces": {
            nameProp:"asociacion-ces",
            value: "asociacion-ces",
            label: "Asociación CES",
            longLabel: "Asociación de animales (CES)",
            faIcon: faCat,
            colorIcon: "#ffc107",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,

        },
        municipal: {
            nameProp:"municipal",
            value: "municipal",
            label: "Municipal",
            longLabel: "Centro Municipal de animales",
            faIcon: faBuildingColumns,
            colorIcon: "#969696",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        protectora: {
            nameProp:"protectora",
            value: "protectora",
            label: "Protectora",
            longLabel: "Protectora de animales",
            faIcon: faPaw,
            colorIcon: "#ff9083",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        refugio: {
            nameProp:"refugio",
            value: "refugio",
            label: "Refugio",
            longLabel: "Refugio de animales",
            faIcon: faHouse,
            colorIcon: "#2bc5c8",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        otro: {
            nameProp:"otro",
            value: "otro",
            label: "Otro",
            longLabel: "Otro tipo",
            faIcon: faPaw,
            colorIcon: "#2bc5c8",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        particular:{
            nameProp:"particular",
            value: "particular",
            label: "Particular",
            longLabel: "Particular",
            faIcon: faUser,
            colorIcon: "#2bc5c8",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
    }
}

export const ICONS = {
    userLoc: {
        faIcon: faCircle,
        colorIcon: "#2d7eff",
        strokeColor: "white",
        scale: ICON_SCALE_USER,
        imageIcon: process.env.CDN_URL + "/images/adoptaunanimal/iconMapLocUser-min.png",

    },
    centroMunicipio: {
        // icon: faCircle,
        // color: "#2d7eff",
        // strokeColor: "white",
        // scale: ICON_SCALE_USER,
        // imageIcon: process.env.CDN_URL + "/images/adoptaunanimal/iconMapLocUser-min.png",
        //#88888880
    },
    mapButton: {
        faIcon: faMapLocationDot,
        // faIcon: faMap,
        colorIcon: "#88888880",
    },
    listingButton: {
        faIcon: faList,
        colorIcon: "#88888880",
    },
    filterButton: {
        faIcon: faFilter,
        colorIcon: "#88888880",
    }
}

// console.log("▼▼▼  globalFrontEndConfig  ▼▼▼")
// console.log({
//     PROCESS_ENV_NODE_ENV: process.env.NODE_ENV,
//     PROCESS_ENV_DEV_ENV: process.env.DEV_ENV,
// })
